import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AnagraficaClassificheService } from 'src/app/core/anagrafica-classifiche.service';
import { AnagraficaQualificheService } from 'src/app/core/anagrafica-qualifiche.service';
import { AnagraficheService } from 'src/app/core/anagrafiche.service';
import { StatisticheService } from 'src/app/core/statistiche.service';
import { Classifica } from 'src/app/shared/models/classifica.model';
import { Qualifica } from 'src/app/shared/models/qualifica.model';
import { Statistica } from 'src/app/shared/models/statistica';
import { AppConfig } from '../../app-config.loader';
import { StoricoStatistiche } from 'src/app/shared/models/storicostatistiche';

@Component({
  selector: 'app-statistiche',
  templateUrl: './statistiche.component.html',
  styleUrls: ['./statistiche.component.css']
})

export class StatisticheComponent implements OnInit, OnDestroy {

  public inCarico: Statistica[] | undefined;
  public distrutti: Statistica[] | undefined;
  public versati: Statistica[] | undefined;
  public declassificati: Statistica[] | undefined;
  public classifiche: Classifica[] = [];
  public qualifiche: Qualifica[] = [];
  public storicoStatistiche: StoricoStatistiche[] = [];

  public anniDisponibili: { display: string, value: string }[] = [];
  public annoSelezionato: string | undefined;

  public AnagraficaClassificheService = AnagraficaClassificheService;
  public AnagraficaQualificheService = AnagraficaQualificheService;

  private subscriber$ = new Subject<void>();

  constructor(private statisticheService: StatisticheService, public anagraficheService: AnagraficheService, private appConfig: AppConfig) { }

  ngOnInit() {
    
    const currentYear = new Date().getFullYear();
    this.anniDisponibili.push({ display: Anno.Tutti, value: '' });
    for (let i = this.appConfig.settings.statisticsStartYear; i <= currentYear; i++) {
      this.anniDisponibili.push({ display: i.toString(), value: i.toString() });
    }
    this.annoSelezionato = '';

    this.anagraficheService.classifiche.getAll().pipe(takeUntil(this.subscriber$)).subscribe(c => this.classifiche = c);
    this.anagraficheService.qualifiche.getAll().pipe(takeUntil(this.subscriber$)).subscribe(q => this.qualifiche = q);
    this.statisticheService.getStoricoStatistiche().pipe(takeUntil(this.subscriber$)).subscribe(s => this.storicoStatistiche = s);
    this.refreshStatistics();
  }

  private refreshStatistics(year?: string) {
    this.statisticheService.getInCarico(year).subscribe(statistiche => this.inCarico = statistiche);
    this.statisticheService.getDistrutti(year).subscribe(statistiche => this.distrutti = statistiche);
    this.statisticheService.getVersati(year).subscribe(statistiche => this.versati = statistiche);
    this.statisticheService.getDeclassificati(year).subscribe(statistiche => this.declassificati = statistiche);
  }

  ngOnDestroy(): void {
    this.subscriber$.next();
    this.subscriber$.complete();
  }

  getClassificaIds(array: Statistica[], arrivo?: boolean): number[] {
    if (arrivo === undefined) {
      return array ? [...new Set(array.map(item => item.classificaId))] : [];
    }
    return array ? [...new Set(array.filter(item => item.arrivo === arrivo).map(item => item.classificaId))] : [];
  }


  getQualificaIds(array: Statistica[], arrivo?: boolean): number[] {
    if (arrivo === undefined) {
      return array ? [...new Set(array.map(item => item.qualificaId))] : [];
    }
    return array ? [...new Set(array.filter(item => item.arrivo === arrivo).map(item => item.qualificaId))] : [];
  }

  getCount(tabellaId: number, array: Statistica[], qualificaId: number, classificaId: number, arrivo?: boolean): number {
    const storicoItem = this.storicoStatistiche.find(item => item.tabellaStatisticaId === tabellaId && item.qualificaId === qualificaId && item.classificaId === classificaId);
    if (arrivo === undefined) {
      const item = array ? array.find(item => item.qualificaId === qualificaId && item.classificaId === classificaId) : undefined;
      // trova l'elemento di storicoStatistiche che ha tabellaId uguale a quello passato come parametro e qualiId e classificaId uguali a quelli passati come parametro
      // se lo trova restituisce il valore di valoreStatistica, altrimenti restituisce 0
      if (storicoItem && this.annoSelezionato === '') {
        const count = item ? item.count : 0;
        return count + storicoItem.valoreStatistica;
      }
      return item ? item.count : 0;
    }
    const item = array ? array.find(item => item.qualificaId === qualificaId && item.classificaId === classificaId && item.arrivo === arrivo) : undefined;
    if (storicoItem && this.annoSelezionato === '') {
      const count = item ? item.count : 0;
      return count + storicoItem.valoreStatistica;
    }
    return item ? item.count : 0;
  }

  changeYear() {
    this.refreshStatistics(this.annoSelezionato);
  }
}
export enum Anno {
  Tutti = 'Tutti'
}
